import { Box, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Header } from "../../components/Header";
import { useParams } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { validationUsuarioEditar } from "../../schemas/usuario";
import { useUsuario } from "../../hooks/usuarios/useUsuario";
import { Loading } from "../../components/Loading";
import { Form } from "../UsuarioNovo/Form";

export function UsuarioEditar(){
  const { id } = useParams() as { id?: string };
  const { data: usuario, isLoading } = useUsuario({ id });

  const form = useForm({
    resolver: zodResolver(validationUsuarioEditar),
  });

  useEffect(() => {
    if (!usuario) {
      return;
    }

    form.reset({
      nome: usuario.nome,
      email: usuario.email,
      password: '',
      status: String(usuario.status),
      tipo: String(usuario.tipo),
    });
  }, [form, usuario]);

  if (isLoading) {
    return <Loading />;
  }
  
    return (
      <FormProvider {...form}>
        <Box
          display={"flex"}
          flexDir={"column"}
          justifyContent={"center"}
          width={"full"}
          alignItems={"center"}
        >
          <Flex
            maxWidth={"90%"}
            width={"100%"}
            flexDir={"column"}
            justifyContent={"center"}
          >
            <Header />
            <Box
              px={"1rem"}
              bg={"white"}
              w={"full"}
              display={"flex"}
              flexDir={"column"}
              gap={"8"}
              pb={8}
            >
              <Form mode="edit" usuarioId={id} />
            </Box>
          </Flex>
        </Box>
      </FormProvider>
    );
}
